export const MYNAVI_PRIMARY = '#058bbe'
